// extracted by mini-css-extract-plugin
export default {"login-button":"login-button_login-button__Lf5i6"};